// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__10c5f","text":"SelectPayment_text__1Wlpz","title":"SelectPayment_title__2zb2v","btn":"SelectPayment_btn__3iTGr"};